export const legendStyles = {
  container: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    py: 2,
  },
};
